import { CustomerInfo, CustomerLoginInfo } from 'orderme-api-integration-client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCustomerNumber } from '../../helpers/localStorageService';

interface CustomerState {
  loginInfo: CustomerLoginInfo;
  customerInfo: CustomerInfo;
}

const initialState = {
  loginInfo: {} as CustomerLoginInfo,
  customerInfo: {} as CustomerInfo,
} as CustomerState;

const customerSlice = createSlice({
  name: 'customer',
  initialState: initialState,
  reducers: {
    updateCustomer: (state, action: PayloadAction<CustomerLoginInfo>) => {
      state.loginInfo = action.payload;
      state.customerInfo = action.payload?.customers[getCustomerNumber()];
    },
    updateCustomerInfo: (state, action: PayloadAction<CustomerInfo>) => {
      state.customerInfo = action.payload;
      const addresses = action.payload?.addresses;
      if (addresses?.length > 0) {
        state.customerInfo.addresses = addresses.filter((x) => x.isValid);
      }
    },
    clearCustomer: (state) => {
      state.customerInfo = initialState.customerInfo;
      state.loginInfo = initialState.loginInfo;
    },
  },
});

export const { updateCustomer, updateCustomerInfo, clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;
